import { FormControl, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';

export abstract class BaseListComponent<T> {
  currentPage: number = 0;
  pageSize: number = 20;
  totalCount: number = 0;
  isLoading: boolean = false;

  pageSettings: {
    defaultPageSize: number,
    pageSizeOptions: number[],
  } = {
    defaultPageSize: 20,
    pageSizeOptions: [20, 50 ,100]
  }

  rowData: T[] = [];

  searchControl: FormControl = new FormControl('');
  sortForm: FormGroup = new FormGroup({
    sortField: new FormControl({ sortValue: '' }),
    isAscending: new FormControl(true),
  });

  currentSortField = { sortValue: '' };
  currentIsAscending = true;

  abstract reload(): void;

  setSortField() {
    const { sortField, isAscending } = this.sortForm.value;
    this.currentSortField = sortField;
    this.currentIsAscending = isAscending;
    this.reload();
  }

  resetSortField() {
    this.sortForm.setValue({
      sortField: this.currentSortField,
      isAscending: this.currentIsAscending,
    });
  }

  handlePageEvent(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.reload();
  }
}
